import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class DeleteCoupon {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(id: string): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.DELETE,
      url: `${Envs.BFF_WEB_URL}/coupons/delete/`,
      body: { couponId: id },
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response.data
    } else {
      throw new GeneralError(response.data?.errorCode)
    }
  }
}
